'use strict';

angular.module('internal.setup')
    .controller('InternalSetup', ['$scope', '$stateParams', 'Enterprise', function ($scope, $stateParams, Enterprise) {
    }])
;